/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type GetModelConfigPathParams = NonNullable<operations['getModelConfig']['parameters']['path']>;

export type GetModelConfigQueryParams = NonNullable<operations['getModelConfig']['parameters']['query']>;

export interface Input extends GetModelConfigPathParams {
  apiVersion?: string;
  query?: GetModelConfigQueryParams;
}

export async function getModelConfig(
  { apiVersion, query, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().GET('/api/v2/projects/{projectKey}/ai-configs/model-configs/{modelConfigKey}', {
    params: { path, query },
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
